import { render, staticRenderFns } from "./PaintingsSlider.vue?vue&type=template&id=0180cbde&scoped=true&"
import script from "./PaintingsSlider.vue?vue&type=script&lang=js&"
export * from "./PaintingsSlider.vue?vue&type=script&lang=js&"
import style0 from "./PaintingsSlider.vue?vue&type=style&index=0&id=0180cbde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0180cbde",
  null
  
)

export default component.exports